import React from 'react';
import {
  IconButton,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react';
import { FiX } from 'react-icons/fi';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../utils/init-firebase';
import { useAuth } from '../../contexts/AuthContext';

export default function RejectLockRequest({ request }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  const toast = useToast();
  const { currentUser } = useAuth();

  const handleReject = async () => {
    try {
      await updateDoc(doc(db, 'RateLockRequests', request.id), {
        status: 'Rejected',
        'Date Rejected': serverTimestamp(),
        rejectedBy: {
          email: currentUser.email,
          name: currentUser.displayName,
          photoURL: currentUser.photoURL,
          uid: currentUser.uid
        }
      });
      
      onClose();
      toast({
        title: 'Rate Lock Request Rejected',
        description: 'The request has been rejected.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Error rejecting rate lock request:', error);
      toast({
        title: 'Error',
        description: 'Failed to reject rate lock request. Please try again.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <IconButton
        icon={<FiX />}
        size="md"
        colorScheme="red"
        variant="ghost"
        onClick={onOpen}
        isDisabled={request.status !== 'Pending'}
      />

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Reject Rate Lock Request
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to reject this rate lock request for {request.rate}%?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleReject} ml={3}>
                Reject
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
} 